

































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IColorDetail } from './types';
import ColorWheelUnit from './ColorUnit.vue';

// 5种关系色
@Component({
  components: { ColorWheelUnit },
})
export default class ColorWheelRelation extends Vue {
  @Prop() public items!: IColorDetail[];                                // 所有颜色列表
  @Prop() public current!: IColorDetail | null;                         // 当前颜色
  @Prop({ type: Boolean, default: false }) public showSelf!: boolean;   // 是否展示当前选中的颜色
  @Prop({ type: Boolean, default: false }) public selectable!: boolean; // 是否允许选择颜色块

  public selectedType = '';                     // 选中数据的关系类型，详见 this.relationList.type
  public selected: IColorDetail | null = null;  // 选中的数据

  // 图标列的样式
  public get labelStyle() {
    const size = this.showSelf ? 64 : 48;
    return { width: `${size}px`, height: `${size}px` };
  }

  // 当前选中的颜色在色盘中的索引值(hue 值等于索引值)
  public get pieSelectIndex() {
    return this.current ? this.current.color.hue : -1;
  }

  // 关系色分类列表
  public get relationList() {
    const i = this.pieSelectIndex;
    const showSelf = this.showSelf;
    const half = Math.floor(this.items.length / 2);
    const third = Math.floor(this.items.length / 3);

    // 列宽
    const similarCols = showSelf ? [12, 3] : [3];
    const reverseCols = showSelf ? [12, 12] : [12];
    const siblingCols = showSelf ? [12, 4] : [4];
    const splitCols = showSelf ? [6, 6] : [4];
    const triangleCols = showSelf ? [12, 6] : [6];

    // 偏移量
    const so = this.getSplitOffsets(i, half);
    const similarOffsets = showSelf ? [0, 2, 1, -1, -2] : [2, 1, -1, -2];
    const reverseOffsets = showSelf ? [0, half] : [half];
    const siblingOffsets = showSelf ? [0, half + 1, half, half - 1] : [half + 1, half, half - 1];
    const splitOffsets = so.length ? (showSelf ? [0, ...so] : so) : [];
    const triangleOffsets = showSelf ? [0, third * 2, third] : [third * 2, third];

    return [
      { type: 'similar', text: '类似色关系', cols: similarCols, list: this.calc(similarOffsets) },
      { type: 'reverse', text: '互补色关系', cols: reverseCols, list: this.calc(reverseOffsets) },
      { type: 'sibling', text: '临近互补色关系', cols: siblingCols, list: this.calc(siblingOffsets) },
      { type: 'split', text: '分裂互补色关系', cols: splitCols, list: this.calc(splitOffsets) },
      { type: 'triangle', text: '正三色关系', cols: triangleCols, list: this.calc(triangleOffsets) },
    ];
  }

  // 分裂互补色偏移量
  public getSplitOffsets(index: number, half: number) {
    if (index === 12 || index === 27) {
      // 当前颜色在 12 和 27 的时候, 无分裂互补色
      return [];
    } else if ((index > 4 && index < 12) || (index > 19 && index < 27)) {
      // 当前颜色在 5 ~ 11 和 20 ~ 26 的时候, 互补色是顺时针偏移
      return [-2, half, half - 2];
    } else {
      // 其他区域, 互补色是逆时针偏移
      return [2, half, half + 2];
    }
  }

  // 通过颜色索引偏移量, 来计算对应关系色
  public calc(offsets: number[]): IColorDetail[] {
    const i = this.pieSelectIndex;
    const total = this.items.length;
    if (i === -1 || total === 0) {
      return [];
    } else {
      const offsetToIndex = offsets.map((offset) => (offset + i + total) % total);
      return offsetToIndex.map((colorIndex) => this.items[colorIndex]);
    }
  }

  // 设置颜色快列宽
  public setCols(record: any, index: number) {
    return index === 0 ? record.cols[0] : record.cols[1];
  }

  // 是否被选中
  public isSelect(record: IColorDetail, type: string) {
    const sel = this.selected;
    const val = `${record.color.hue}_${record.color.sb}`;
    const sVal = sel ? `${sel.color.hue}_${sel.color.sb}` : '';
    return this.selectedType === type && sVal === val;
  }

  // 取消选中
  @Emit('select')
  public unselect() {
    this.selectedType = '';
    this.selected = null;
    return null;
  }

  // 颜色被选中或取消选中时
  @Emit('select')
  public onToggleSelect(record: IColorDetail, type: string) {
    const isSelected = this.isSelect(record, type);
    this.selectedType = isSelected ? '' : type;
    this.selected = isSelected ? null : record;
    return this.selected;
  }

  // 饼图选中的数据变更时，清除选中
  @Watch('current')
  public currentChange() {
    this.unselect();
  }
}
